<div class="bp-modal mod-lg">
  <bp-modal-header header class="font-semibold" [title]="'preview_title' | translate">
    <a (click)="back()" left (keydown.enter)="back()" [tabIndex]="0">{{ "back" | translate }}</a>
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section pb-25">
      @if (shareUrl$ | async; as shareUrl) {
        <div>
          @if (locaKey | translate: [assetName, ' ']; as shareText) {
            <div class="share-content-inner mb-40">
              <div class="share-hidden"></div>
              @if (showImage) {
                <div class="share-img">
                  <img
                    class="static-image"
                    src="/assets/images/share-static-image.svg"
                    alt="{{ 'logo_alt_text' | translate }}" />
                  <div class="share-trade-text ml-10 mt-10">
                    {{ shareText }}
                  </div>
                  <span class="share-trade-text text-green ml-10">
                    {{ shareUrl }}
                  </span>
                </div>
              } @else {
                <img
                  class="background-circles invert-svg-fill"
                  src="/assets/images/svg/background-circles.svg"
                  alt="background-circles" />
                <div class="share-text-box">
                  <div class="message-box-text mt-10">
                    {{ shareText }}
                  </div>
                  <span class="message-box-text text-green">
                    {{ shareUrl }}
                  </span>
                </div>
              }
              <div class="social-platforms">
                <a href="mailto:?body={{ locaKey | translate: [assetName, shareUrl] }}">
                  <img src="/assets/images/icons/icon-share-email.svg" alt="mail" />
                </a>
                <a href="#" (click)="shareTwitter(shareUrl, shareText); $event.preventDefault()">
                  <svg-inline src="/assets/images/icons/icon-share-twitter.svg" alt="twitter" />
                </a>
                <a href="#" (click)="shareReddit(shareUrl, shareText); $event.preventDefault()">
                  <svg-inline src="/assets/images/icons/icon-share-reddit.svg" alt="reddit" />
                </a>
                <a href="#" (click)="shareFacebook(shareUrl); $event.preventDefault()">
                  <svg-inline src="/assets/images/icons/icon-share-facebook.svg" alt="facebook" />
                </a>
                <a href="#" (click)="shareLinkedin(shareUrl); $event.preventDefault()">
                  <svg-inline src="/assets/images/icons/icon-share-linkedin.svg" alt="linkedin" />
                </a>
                <svg-inline
                  [copyToClipboard]="locaKey | translate: [assetName, shareUrl]"
                  [copyInfo]="'copied_tag_to_clipboard' | translate"
                  [toastType]="toastType"
                  src="/assets/images/icons/icon-share-clipboard.svg"
                  alt="clipboard" />
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
